import { render, staticRenderFns } from "./GrcNum.vue?vue&type=template&id=4003efbd&scoped=true&"
import script from "./GrcNum.vue?vue&type=script&lang=js&"
export * from "./GrcNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003efbd",
  null
  
)

export default component.exports